module.exports = __webpack_public_path__ + "img/GroupBot-Logo-Primary.afb77e09.png";